




// import React, { useState, useEffect, useCallback } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { collection, query, where, getDocs, limit } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './TrendingProducts.css';
// // Import FloatingActions component
// import FloatingActions from '../FloatingActions/FloatingActions';
// // Import helper functions
// import { dispatchCompareUpdate, dispatchWishlistUpdate } from '../FloatingActions/actionHelpers';

// const TrendingProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         setLoading(true);
        
//         const productsQuery = query(
//           collection(db, 'products'),
//           where('active', '==', true),
//           limit(8) // Limit to 8 trending products for better display
//         );
        
//         const querySnapshot = await getDocs(productsQuery);
        
//         if (querySnapshot.empty) {
//           console.log("No active products found");
//           setProducts([]);
//           setLoading(false);
//           return;
//         }
        
//         const productsData = querySnapshot.docs.map(doc => {
//           const data = doc.data();
//           return {
//             id: doc.id,
//             ...data,
//             deliverySpeed: data.deliverySpeed || 'normal',
//             originalDeliverySpeed: data.deliverySpeed || 'normal',
//             isQuick: data.deliverySpeed === 'quick',
//             // Add default model and weight if they don't exist
//             model: data.model || `M${doc.id.substring(0, 5)}`,
//             weight: data.weight || '250g'
//           };
//         });
        
//         const sortedProducts = productsData.sort((a, b) => {
//           const dateA = a.createdAt ? 
//             (a.createdAt.toDate ? a.createdAt.toDate() : new Date(a.createdAt)) : 
//             new Date(0);
            
//           const dateB = b.createdAt ? 
//             (b.createdAt.toDate ? b.createdAt.toDate() : new Date(b.createdAt)) : 
//             new Date(0);
            
//           return dateB - dateA;
//         });
        
//         setProducts(sortedProducts);
//       } catch (err) {
//         console.error("Error fetching products:", err);
//         setError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProducts();
//   }, []);

//   if (loading) {
//     return (
//       <section className="trending-section">
//         <div className="container">
//           <h2 className="section-title">Trending Components</h2>
//           <div className="products-loading">Loading trending products...</div>
//         </div>
//       </section>
//     );
//   }

//   if (error) {
//     return (
//       <section className="trending-section">
//         <div className="container">
//           <h2 className="section-title">Trending Components</h2>
//           <div className="products-error">Error loading products. Please refresh the page.</div>
//         </div>
//       </section>
//     );
//   }

//   if (products.length === 0) {
//     return null;
//   }

//   return (
//     <section className="trending-section">
//       <div className="container">
//         <h2 className="section-title">Trending Components</h2>
//         <div className="products-grid1">
//           {products.map(product => (
//             <ProductCard key={product.id} product={product} />
//           ))}
//         </div>
//       </div>
      
//       {/* Add FloatingActions component here */}
//       <FloatingActions />
//     </section>
//   );
// };

// const ProductCard = ({ product }) => {
//   const navigate = useNavigate();
//   const [quantity, setQuantity] = useState(1);
//   const [inCart, setInCart] = useState(false);
//   const [imageError, setImageError] = useState(false);
//   const [inWishList, setInWishList] = useState(false);
//   const [isCompared, setIsCompared] = useState(false);
  
//   // Calculate discounted price (10% off)
//   const originalPrice = product.price || 0;
//   const discountPercentage = 10;
//   const discountedPrice = originalPrice * (1 - discountPercentage / 100);

//   // Function to check if product is in cart
//   const checkProductInCart = useCallback(() => {
//     const existingCart = localStorage.getItem('cartItems');
//     if (existingCart) {
//       try {
//         const parsedCart = JSON.parse(existingCart);
//         const cartArray = Array.isArray(parsedCart) ? parsedCart : [];
        
//         const existingProduct = cartArray.find(item => item.id === product.id);
//         if (existingProduct) {
//           setInCart(true);
//           setQuantity(existingProduct.quantity || 1);
//         } else {
//           setInCart(false);
//           setQuantity(1);
//         }
//       } catch (error) {
//         console.error("Error parsing cart items:", error);
//         setInCart(false);
//         setQuantity(1);
//       }
//     } else {
//       setInCart(false);
//       setQuantity(1);
//     }
//   }, [product.id]);

//   // Function to check if product is in wish list
//   const checkProductInWishList = useCallback(() => {
//     const existingWishList = localStorage.getItem('wishListItems');
//     if (existingWishList) {
//       try {
//         const parsedWishList = JSON.parse(existingWishList);
//         const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];
        
//         const existingProduct = wishListArray.find(item => item.id === product.id);
//         setInWishList(!!existingProduct);
//       } catch (error) {
//         console.error("Error parsing wish list items:", error);
//         setInWishList(false);
//       }
//     } else {
//       setInWishList(false);
//     }
//   }, [product.id]);

//   // Function to check if product is in compare list
//   const checkProductInCompare = useCallback(() => {
//     const existingCompareList = localStorage.getItem('compareItems');
//     if (existingCompareList) {
//       try {
//         const parsedCompareList = JSON.parse(existingCompareList);
//         const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];
        
//         const existingProduct = compareArray.find(item => item.id === product.id);
//         setIsCompared(!!existingProduct);
//       } catch (error) {
//         console.error("Error parsing compare items:", error);
//         setIsCompared(false);
//       }
//     } else {
//       setIsCompared(false);
//     }
//   }, [product.id]);

//   useEffect(() => {
//     checkProductInCart();
//     checkProductInWishList();
//     checkProductInCompare();
    
//     const handleCartUpdate = () => {
//       checkProductInCart();
//     };
    
//     // Add event listeners for compare and wishlist updates
//     const handleCompareUpdate = () => {
//       checkProductInCompare();
//     };
    
//     const handleWishlistUpdate = () => {
//       checkProductInWishList();
//     };
    
//     window.addEventListener('cartUpdated', handleCartUpdate);
//     window.addEventListener('compareUpdated', handleCompareUpdate);
//     window.addEventListener('wishlistUpdated', handleWishlistUpdate);
    
//     return () => {
//       window.removeEventListener('cartUpdated', handleCartUpdate);
//       window.removeEventListener('compareUpdated', handleCompareUpdate);
//       window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
//     };
//   }, [checkProductInCart, checkProductInWishList, checkProductInCompare]);
  
//   const dispatchCartUpdate = () => {
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   const getCurrentCart = () => {
//     const existingCart = localStorage.getItem('cartItems');
//     if (existingCart) {
//       try {
//         const parsedCart = JSON.parse(existingCart);
//         return Array.isArray(parsedCart) ? parsedCart : [];
//       } catch (error) {
//         console.error("Error parsing cart items:", error);
//         return [];
//       }
//     }
//     return [];
//   };

//   const handleAddToCart = (e) => {
//     e.stopPropagation();
    
//     const currentCart = getCurrentCart();
//     const existingProductIndex = currentCart.findIndex(item => item.id === product.id);
    
//     let updatedCart;
//     if (existingProductIndex >= 0) {
//       updatedCart = [...currentCart];
//       updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + quantity;
//     } else {
//       const cartItem = {
//         id: product.id,
//         name: product.name,
//         price: discountedPrice, // Use the discounted price for cart
//         originalPrice: originalPrice, // Store original price for reference
//         quantity: quantity,
//         imageUrl: product.imageUrl,
//         image: product.imageUrl,
//         deliverySpeed: product.deliverySpeed || 'normal',
//         originalDeliverySpeed: product.deliverySpeed || 'normal'
//       };
      
//       updatedCart = [...currentCart, cartItem];
//     }
    
//     localStorage.setItem('cartItems', JSON.stringify(updatedCart));
//     setInCart(true);
    
//     dispatchCartUpdate();
//   };

//   const handleViewDetails = (e) => {
//     // Navigate to product details page
//     navigate(`/products/${product.id}`);
//   };

//   const handleCompare = (e) => {
//     e.stopPropagation();
    
//     const existingCompareList = localStorage.getItem('compareItems');
//     let compareList = [];
    
//     if (existingCompareList) {
//       try {
//         compareList = JSON.parse(existingCompareList);
//         if (!Array.isArray(compareList)) compareList = [];
//       } catch (error) {
//         console.error("Error parsing compare list:", error);
//       }
//     }
    
//     if (!isCompared) {
//       // Add model and weight to the compare object
//       compareList.push({
//         id: product.id,
//         name: product.name,
//         price: discountedPrice, // Use the discounted price
//         originalPrice: originalPrice, // Store original price
//         imageUrl: product.imageUrl,
//         image: product.imageUrl,
//         description: product.description || '',
//         deliverySpeed: product.deliverySpeed || 'normal',
//         // Add model and weight fields
//         model: product.model || `M${product.id.substring(0, 5)}`,
//         weight: product.weight || '250g'
//       });
//       setIsCompared(true);
//     } else {
//       compareList = compareList.filter(item => item.id !== product.id);
//       setIsCompared(false);
//     }
    
//     localStorage.setItem('compareItems', JSON.stringify(compareList));
//     // Dispatch compare update event to update the FloatingActions badge
//     dispatchCompareUpdate();
//   };

//   const handleAddToWishList = (e) => {
//     e.stopPropagation();
    
//     const existingWishList = localStorage.getItem('wishListItems');
//     let wishList = [];
    
//     if (existingWishList) {
//       try {
//         wishList = JSON.parse(existingWishList);
//         if (!Array.isArray(wishList)) wishList = [];
//       } catch (error) {
//         console.error("Error parsing wish list:", error);
//       }
//     }
    
//     if (!inWishList) {
//       // Add model and weight to the wishlist object as well for consistency
//       wishList.push({
//         id: product.id,
//         name: product.name,
//         price: discountedPrice, // Use the discounted price
//         originalPrice: originalPrice, // Store original price
//         imageUrl: product.imageUrl,
//         image: product.imageUrl,
//         description: product.description || '',
//         deliverySpeed: product.deliverySpeed || 'normal',
//         // Add model and weight fields
//         model: product.model || `M${product.id.substring(0, 5)}`,
//         weight: product.weight || '250g'
//       });
//       setInWishList(true);
//     } else {
//       wishList = wishList.filter(item => item.id !== product.id);
//       setInWishList(false);
//     }
    
//     localStorage.setItem('wishListItems', JSON.stringify(wishList));
//     // Dispatch wishlist update event to update the FloatingActions badge
//     dispatchWishlistUpdate();
//   };

//   const handleImageError = () => {
//     setImageError(true);
//   };

//   // Get the correct image URL
//   const getImageUrl = () => {
//     if (product.imageUrl && !imageError) {
//       return product.imageUrl;
//     }
//     if (product.image && !imageError) {
//       return product.image;
//     }
//     return "/images/product-placeholder.jpg";
//   };

//   const getDeliveryBadge = (deliverySpeed) => {
//     switch (deliverySpeed) {
//       case 'quick':
//         return <span className="delivery-badge quick-delivery">QUICK</span>;
//       case 'express':
//         return <span className="delivery-badge express-delivery">EXPRESS</span>;
//       case 'standard':
//         return <span className="delivery-badge standard-delivery">STANDARD</span>;
//       case 'late':
//         return <span className="delivery-badge late-delivery">LATE</span>;
//       case 'normal':
//       default:
//         return <span className="delivery-badge normal-delivery">NORMAL</span>;
//     }
//   };

//   // Truncate long product names
//   const truncateName = (name) => {
//     return name && name.length > 50 ? name.substring(0, 47) + '...' : name;
//   };

//   return (
//     <div className="product-card">
//       <div 
//         className="product-image-container"
//         onClick={handleViewDetails}
//       >
//         <img 
//           src={getImageUrl()}
//           alt={product.name}
//           className="product-image"
//           onError={handleImageError}
//         />
//         {/* Delivery Badge - Right side */}
//         <div className="delivery-badge-overlay">
//           {getDeliveryBadge(product.deliverySpeed)}
//         </div>
        
//         {/* Discount Badge - Left side */}
//         <div className="discount-badge-overlay">
//           <span className="discount-badge">10%</span>
//         </div>
//       </div>
      
//       <div className="product-info" onClick={handleViewDetails}>
//         <h3 className="product-name">{truncateName(product.name)}</h3>
//         <div className="product-price">
//           <span className="original-price">₹{originalPrice.toFixed(2)}</span>
//           <span className="discounted-price">₹{discountedPrice.toFixed(2)}</span>
//         </div>
//         <Link to={`/products/${product.id}`} className="view-details-btn">
//           View Details
//         </Link>
//       </div>
      
//       <div className="product-actions">
//         <button 
//           className={`action-btn compare-btn ${isCompared ? 'active' : ''}`}
//           onClick={handleCompare}
//         >
//           <span className="action-icon">⟲</span>
//           <span>Compare</span>
//         </button>
        
//         <button 
//           className={`action-btn cart-btn ${inCart ? 'active' : ''}`}
//           onClick={handleAddToCart}
//         >
//           <span className="action-icon">🛒</span>
//           <span>Add to Cart</span>
//         </button>
        
//         <button 
//           className={`action-btn wishlist-btn ${inWishList ? 'active' : ''}`}
//           onClick={handleAddToWishList}
//         >
//           <span className="action-icon">♡</span>
//           <span>Wishlist</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default TrendingProducts;








import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './TrendingProducts.css';
// Import FloatingActions component
import FloatingActions from '../FloatingActions/FloatingActions';
// Import helper functions
import { dispatchCompareUpdate, dispatchWishlistUpdate } from '../FloatingActions/actionHelpers';

const TrendingProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        
        const productsQuery = query(
          collection(db, 'products'),
          where('active', '==', true),
          limit(8) // Limit to 8 trending products for better display
        );
        
        const querySnapshot = await getDocs(productsQuery);
        
        if (querySnapshot.empty) {
          console.log("No active products found");
          setProducts([]);
          setLoading(false);
          return;
        }
        
        const productsData = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            deliverySpeed: data.deliverySpeed || 'normal',
            originalDeliverySpeed: data.deliverySpeed || 'normal',
            isQuick: data.deliverySpeed === 'quick',
            // Add default model and weight if they don't exist
            model: data.model || `M${doc.id.substring(0, 5)}`,
            weight: data.weight || '250g',
            // Ensure price fields are set correctly
            price: data.price || 0,
            originalPrice: data.originalPrice || data.price || 0,
            discountPercentage: data.discountPercentage || 0
          };
        });
        
        const sortedProducts = productsData.sort((a, b) => {
          const dateA = a.createdAt ? 
            (a.createdAt.toDate ? a.createdAt.toDate() : new Date(a.createdAt)) : 
            new Date(0);
            
          const dateB = b.createdAt ? 
            (b.createdAt.toDate ? b.createdAt.toDate() : new Date(b.createdAt)) : 
            new Date(0);
            
          return dateB - dateA;
        });
        
        setProducts(sortedProducts);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="trending-section">
        <div className="container">
          <h2 className="section-title">Trending Components</h2>
          <div className="products-loading">Loading trending products...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="trending-section">
        <div className="container">
          <h2 className="section-title">Trending Components</h2>
          <div className="products-error">Error loading products. Please refresh the page.</div>
        </div>
      </section>
    );
  }

  if (products.length === 0) {
    return null;
  }

  return (
    <section className="trending-section">
      <div className="container">
        <h2 className="section-title">Trending Components</h2>
        <div className="products-grid1">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
      
      {/* Add FloatingActions component here */}
      <FloatingActions />
    </section>
  );
};

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [inCart, setInCart] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [inWishList, setInWishList] = useState(false);
  const [isCompared, setIsCompared] = useState(false);
  
  // Get price information from the product data
  const originalPrice = product.originalPrice || product.price || 0;
  const discountPercentage = product.discountPercentage || 0;
  const sellingPrice = product.price || 0;
  
  // Determine if there's a discount
  const hasDiscount = discountPercentage > 0 && originalPrice > sellingPrice;

  // Function to check if product is in cart
  const checkProductInCart = useCallback(() => {
    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        const cartArray = Array.isArray(parsedCart) ? parsedCart : [];
        
        const existingProduct = cartArray.find(item => item.id === product.id);
        if (existingProduct) {
          setInCart(true);
          setQuantity(existingProduct.quantity || 1);
        } else {
          setInCart(false);
          setQuantity(1);
        }
      } catch (error) {
        console.error("Error parsing cart items:", error);
        setInCart(false);
        setQuantity(1);
      }
    } else {
      setInCart(false);
      setQuantity(1);
    }
  }, [product.id]);

  // Function to check if product is in wish list
  const checkProductInWishList = useCallback(() => {
    const existingWishList = localStorage.getItem('wishListItems');
    if (existingWishList) {
      try {
        const parsedWishList = JSON.parse(existingWishList);
        const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];
        
        const existingProduct = wishListArray.find(item => item.id === product.id);
        setInWishList(!!existingProduct);
      } catch (error) {
        console.error("Error parsing wish list items:", error);
        setInWishList(false);
      }
    } else {
      setInWishList(false);
    }
  }, [product.id]);

  // Function to check if product is in compare list
  const checkProductInCompare = useCallback(() => {
    const existingCompareList = localStorage.getItem('compareItems');
    if (existingCompareList) {
      try {
        const parsedCompareList = JSON.parse(existingCompareList);
        const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];
        
        const existingProduct = compareArray.find(item => item.id === product.id);
        setIsCompared(!!existingProduct);
      } catch (error) {
        console.error("Error parsing compare items:", error);
        setIsCompared(false);
      }
    } else {
      setIsCompared(false);
    }
  }, [product.id]);

  useEffect(() => {
    checkProductInCart();
    checkProductInWishList();
    checkProductInCompare();
    
    const handleCartUpdate = () => {
      checkProductInCart();
    };
    
    // Add event listeners for compare and wishlist updates
    const handleCompareUpdate = () => {
      checkProductInCompare();
    };
    
    const handleWishlistUpdate = () => {
      checkProductInWishList();
    };
    
    window.addEventListener('cartUpdated', handleCartUpdate);
    window.addEventListener('compareUpdated', handleCompareUpdate);
    window.addEventListener('wishlistUpdated', handleWishlistUpdate);
    
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
      window.removeEventListener('compareUpdated', handleCompareUpdate);
      window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
    };
  }, [checkProductInCart, checkProductInWishList, checkProductInCompare]);
  
  const dispatchCartUpdate = () => {
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  const getCurrentCart = () => {
    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        return Array.isArray(parsedCart) ? parsedCart : [];
      } catch (error) {
        console.error("Error parsing cart items:", error);
        return [];
      }
    }
    return [];
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    
    const currentCart = getCurrentCart();
    const existingProductIndex = currentCart.findIndex(item => item.id === product.id);
    
    let updatedCart;
    if (existingProductIndex >= 0) {
      updatedCart = [...currentCart];
      updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + quantity;
    } else {
      const cartItem = {
        id: product.id,
        name: product.name,
        price: sellingPrice, // Use the selling price for cart
        originalPrice: originalPrice, // Store original price for reference
        discountPercentage: discountPercentage, // Store discount percentage
        quantity: quantity,
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        deliverySpeed: product.deliverySpeed || 'normal',
        originalDeliverySpeed: product.deliverySpeed || 'normal'
      };
      
      updatedCart = [...currentCart, cartItem];
    }
    
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    setInCart(true);
    
    dispatchCartUpdate();
  };

  const handleViewDetails = (e) => {
    // Navigate to product details page
    navigate(`/products/${product.id}`);
  };

  const handleCompare = (e) => {
    e.stopPropagation();
    
    const existingCompareList = localStorage.getItem('compareItems');
    let compareList = [];
    
    if (existingCompareList) {
      try {
        compareList = JSON.parse(existingCompareList);
        if (!Array.isArray(compareList)) compareList = [];
      } catch (error) {
        console.error("Error parsing compare list:", error);
      }
    }
    
    if (!isCompared) {
      // Add model and weight to the compare object
      compareList.push({
        id: product.id,
        name: product.name,
        price: sellingPrice, // Use the selling price
        originalPrice: originalPrice, // Store original price
        discountPercentage: discountPercentage, // Store discount percentage
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        description: product.description || '',
        deliverySpeed: product.deliverySpeed || 'normal',
        // Add model and weight fields
        model: product.model || `M${product.id.substring(0, 5)}`,
        weight: product.weight || '250g'
      });
      setIsCompared(true);
    } else {
      compareList = compareList.filter(item => item.id !== product.id);
      setIsCompared(false);
    }
    
    localStorage.setItem('compareItems', JSON.stringify(compareList));
    // Dispatch compare update event to update the FloatingActions badge
    dispatchCompareUpdate();
  };

  const handleAddToWishList = (e) => {
    e.stopPropagation();
    
    const existingWishList = localStorage.getItem('wishListItems');
    let wishList = [];
    
    if (existingWishList) {
      try {
        wishList = JSON.parse(existingWishList);
        if (!Array.isArray(wishList)) wishList = [];
      } catch (error) {
        console.error("Error parsing wish list:", error);
      }
    }
    
    if (!inWishList) {
      // Add model and weight to the wishlist object as well for consistency
      wishList.push({
        id: product.id,
        name: product.name,
        price: sellingPrice, // Use the selling price
        originalPrice: originalPrice, // Store original price
        discountPercentage: discountPercentage, // Store discount percentage
        imageUrl: product.imageUrl,
        image: product.imageUrl,
        description: product.description || '',
        deliverySpeed: product.deliverySpeed || 'normal',
        // Add model and weight fields
        model: product.model || `M${product.id.substring(0, 5)}`,
        weight: product.weight || '250g'
      });
      setInWishList(true);
    } else {
      wishList = wishList.filter(item => item.id !== product.id);
      setInWishList(false);
    }
    
    localStorage.setItem('wishListItems', JSON.stringify(wishList));
    // Dispatch wishlist update event to update the FloatingActions badge
    dispatchWishlistUpdate();
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // Get the correct image URL
  const getImageUrl = () => {
    if (product.imageUrl && !imageError) {
      return product.imageUrl;
    }
    if (product.image && !imageError) {
      return product.image;
    }
    return "/images/product-placeholder.jpg";
  };

  const getDeliveryBadge = (deliverySpeed) => {
    switch (deliverySpeed) {
      case 'quick':
        return <span className="delivery-badge quick-delivery">QUICK</span>;
      case 'express':
        return <span className="delivery-badge express-delivery">EXPRESS</span>;
      case 'standard':
        return <span className="delivery-badge standard-delivery">STANDARD</span>;
      case 'late':
        return <span className="delivery-badge late-delivery">Eco</span>;
      case 'normal':
      default:
        return <span className="delivery-badge normal-delivery">STANDARD</span>;
    }
  };

  // Truncate long product names
  const truncateName = (name) => {
    return name && name.length > 50 ? name.substring(0, 47) + '...' : name;
  };

  return (
    <div className="product-card">
      <div 
        className="product-image-container"
        onClick={handleViewDetails}
      >
        <img 
          src={getImageUrl()}
          alt={product.name}
          className="product-image"
          onError={handleImageError}
        />
        {/* Delivery Badge - Right side */}
        <div className="delivery-badge-overlay">
          {getDeliveryBadge(product.deliverySpeed)}
        </div>
        
        {/* Discount Badge - Left side - Only show if there's a discount */}
        {hasDiscount && (
          <div className="discount-badge-overlay">
            <span className="discount-badge">{discountPercentage}%</span>
          </div>
        )}
      </div>
      
      <div className="product-info" onClick={handleViewDetails}>
        <h3 className="product-name">{truncateName(product.name)}</h3>
        <div className="product-price">
          {hasDiscount ? (
            <>
              <span className="original-price">₹{originalPrice.toFixed(2)}</span>
              <span className="discounted-price">₹{sellingPrice.toFixed(2)}</span>
            </>
          ) : (
            <span className="regular-price">₹{sellingPrice.toFixed(2)}</span>
          )}
        </div>
        <Link to={`/products/${product.id}`} className="view-details-btn">
          View Details
        </Link>
      </div>
      
      <div className="product-actions">
        <button 
          className={`action-btn compare-btn ${isCompared ? 'active' : ''}`}
          onClick={handleCompare}
        >
          <span className="action-icon">⟲</span>
          <span>Compare</span>
        </button>
        
        <button 
          className={`action-btn cart-btn ${inCart ? 'active' : ''}`}
          onClick={handleAddToCart}
        >
          <span className="action-icon">🛒</span>
          <span>Add to Cart</span>
        </button>
        
        <button 
          className={`action-btn wishlist-btn ${inWishList ? 'active' : ''}`}
          onClick={handleAddToWishList}
        >
          <span className="action-icon">♡</span>
          <span>Wishlist</span>
        </button>
      </div>
    </div>
  );
};

export default TrendingProducts;